import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { MASCOT } from "@/lib/games";

export default function PlaySelectChild() {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/children");
      setChildren(data);
      setLoading(false);
    })();
  }, []);

  const pick = (c) => {
    localStorage.setItem("active_child", JSON.stringify(c));
    navigate("/play/hub");
  };

  return (
    <div className="kid-mode min-h-screen flex flex-col items-center justify-center p-8 bg-gradient-to-b from-sky-200 via-sky-100 to-amber-50">
      <img src={MASCOT} alt="Mascote Mundo NeuroKids" className="w-40 h-40 object-contain float-soft" />
      <h1 className="text-4xl md:text-5xl mt-6 text-center">Quem vai brincar hoje?</h1>
      <p className="text-slate-600 mt-3 text-center max-w-xl">
        Escolha seu personagem e vamos explorar a Ilha das Descobertas!
      </p>

      {loading ? (
        <p className="mt-8 text-slate-500">Carregando…</p>
      ) : children.length === 0 ? (
        <div className="kid-card mt-8 text-center max-w-md">
          <p className="text-slate-700 mb-4">
            Nenhum perfil cadastrado ainda. Peça para um adulto criar um perfil no painel clínico.
          </p>
          <button
            onClick={() => navigate("/dashboard/children")}
            className="kid-btn bg-sky-500 text-white"
            data-testid="goto-children-mgmt"
          >
            Ir para o painel
          </button>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-6 max-w-3xl" data-testid="child-picker">
          {children.map((c) => (
            <button
              key={c.id}
              onClick={() => pick(c)}
              className="kid-card flex flex-col items-center gap-3 transition hover:-translate-y-1"
              data-testid={`pick-child-${c.id}`}
            >
              <div
                className="w-24 h-24 rounded-full flex items-center justify-center text-5xl shadow-inner"
                style={{ background: c.avatar_color }}
              >
                {c.avatar_emoji}
              </div>
              <div className="text-xl font-bold">{c.name}</div>
              <div className="text-sm text-slate-500">{c.age} anos · {c.coins} 🪙</div>
            </button>
          ))}
        </div>
      )}

      <button
        onClick={() => navigate("/dashboard")}
        className="mt-10 text-sm text-slate-600 underline"
        data-testid="back-to-dashboard"
      >
        Voltar ao painel
      </button>
    </div>
  );
}
